import type { AxiosError } from 'axios';

export const isRegistrationAuthenticationError = (
  error: AxiosError,
  url: string
): boolean => {
  return (
    (error.response?.status === 400 &&
      (error.response?.data as { code?: string })?.code === 'STATE_INVALID') ||
    (error.response?.status === 401 &&
      (error.response?.data as { code?: string })?.code ===
        'AUTHENTICATION_FAILED' &&
      url.includes('registration'))
  );
};
